// Sentry init — safe no-op when VITE_SENTRY_DSN is not set (local dev, previews).
// Source-map upload happens at build time via @sentry/vite-plugin (see vite.config.ts).
import * as Sentry from "@sentry/react";

let initialized = false;

// Sentry DSN is a publishable credential — safe to ship in client code.
// It only allows sending events; it cannot read data from Sentry.
const SENTRY_DSN =
  (import.meta.env.VITE_SENTRY_DSN as string | undefined) ||
  "https://ce4e57390cfe289d2b2c8e48a2d612cd@o4511270692585472.ingest.de.sentry.io/4511270693699664";

export function isSentryConfigured() {
  return Boolean(SENTRY_DSN);
}

export function isSentryInitialized() {
  return initialized;
}

export function initSentry() {
  if (initialized) return;
  if (typeof window === "undefined") return; // client-only

  const dsn = SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    // 10% perf trace sampling — keeps free-tier usage low while still surfacing slow paths.
    tracesSampleRate: 0.1,
    // Session replays disabled by default; record only when an error happens.
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    // Strip query strings from URLs in events (may contain redeem tokens).
    beforeSend(event) {
      if (event.request?.url) {
        try {
          const u = new URL(event.request.url);
          u.search = "";
          event.request.url = u.toString();
        } catch {
          /* ignore */
        }
      }
      return event;
    },
  });

  initialized = true;
}

export { Sentry };
